import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Api from "./services/Api";
import WebConstant from "./WebConstant";
import DOMPurify from "dompurify";
import { isValidUrl } from "./utility/IamLoginUtils";
import { getCookie } from "./utility/WebAnalytic";

const LoginAs = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  console.log("searchParams", searchParams);
  //const [loading, setLoading] = React.useState(true);
 //const [authResponse, setAuthResponse] = React.useState(null);
 // const [destinationPage, setDestinationPage] = React.useState(null);
  useEffect(() => {
    const fetchUrl = async () => {
      //get query parameter from url for  signOnPolicy
      const urlParams = new URLSearchParams(window.location.search);
      let unifiedTst = urlParams.get("laTst");
      let userName = urlParams.get("userName");
      let appId = urlParams.get("appId");
      let destinationPage = "";
      if (unifiedTst == null || userName == null) {
        console.log("Missing required parameters");
        navigate("/login/error");
        return;
      }
      let DURL =
        urlParams.get(WebConstant.DURL) ||
        urlParams.get(WebConstant.DESTINATION_PAGE);

      let authRequest = {
        tst: unifiedTst,
        username: userName,
      };
      if (appId) {
        authRequest.appId = isNaN(appId) ? 466:Number(appId);
      }

      if (DURL && isValidUrl(DURL)) {
        authRequest.destinationUrl = DURL;
      }

      try {
        let result = await Api.getLoginAs(authRequest);
        console.log("result", result);
        console.log("result.destinationUrl", result.destinationUrl);
        if (result.destinationUrl) {
          //sessionStorage.setItem(WebConstant.DURL, result.destinationUrl);
          destinationPage = result.destinationUrl;
        }
        /* setAuthResponse(result);
        setLoading(false);
        setDestinationPage(destinationPage); */

        //create the cb cookies for login
        let domain = ".collegeboard.org";
        let cbLoginCookie = `${WebConstant.cbLoginCookieName}=${result.unifiedSessionId}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
        document.cookie = cbLoginCookie;

        let cbTreeEnvCookie = `${WebConstant.cbTreeEnvCookieName}=pine; Path=/; Secure; SameSite=Strict; domain=${domain}`;
        if (window.appConfig.envName !== "prod") {
          cbTreeEnvCookie = `${WebConstant.cbTreeEnvCookieName}=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
            let lowerEnvCookie = `lower_Env=${window.appConfig.envName}; Path=/; Secure; SameSite=Strict; domain=${domain}`;
            document.cookie = lowerEnvCookie;
        }
        document.cookie = cbTreeEnvCookie;

        //drop web analytics cookie
        dropWebAnalyticsCookie(result, appId);

        //navigate to destination page
        if (destinationPage) {
          const sanitizedDURL = DOMPurify.sanitize(destinationPage);
          window.location = sanitizedDURL;
        } else {
          navigate("/login/error");
        }
      } catch (error) {
        console.error("Error occurred when calling login as service!");
        console.log("error", error);
        navigate("/login/error");
      }
    };

    fetchUrl();
  }, []);

  function dropWebAnalyticsCookie(authSessionInfo, appId) {
    // Extract namespace from authSessionInfo (assumed to be an object)
    const namespaceInLoginSession = authSessionInfo.namespace;
    let person = {
      accountId: authSessionInfo.accountId,
      oktaAccountId: authSessionInfo.oktaAccountId,
    };

    // // Helper function to create cookie data (simulating WebAnaylyticsCookieManager.getCookie)
    const cookieValue = getCookie(
      person,
      namespaceInLoginSession.toLowerCase(),
      appId ? appId : 466
    );
    document.cookie = `iamkiwilog=${cookieValue}; domain=.collegeboard.org; max-age=300; Secure; SameSite=Strict; Path=/`;
  }
  // Render a loading state while the token exchange happens
  /* return (
    <div>
      {loading ? (
        <h2>Processing authentication...</h2>
      ) : (
        <div>
          {authResponse && (
            <div className="login-as">
              <p>Debug only: authResponse: {authResponse.unifiedSessionId}</p>
              <p>Debug only: destination: {destinationPage}</p>
            </div>
          )}
        </div>
      )}
    </div>
  ); */
  return null
};
export default LoginAs;
